export const JIO_CINEMA_TITLE = 'JioCinema';
export const WORLD_CUP_MAIN_TEXT = 'World Cup 2022 Live';
export const WORLD_CUP_SUB_TEXT = 'from 20 Nov to 18 Dec';
export const APP_RATING = '3.8';
export const APP_DOWNLOADS = '10Cr+ Downloads';
export const MIN_LIKES = 50;
//# sourceMappingURL=jioBannerConstants.js.map